import "./App.css";
import "./styles/main.scss";
import { Header } from "./layout/Header.jsx";
import { Home } from "./pages/home.jsx";
import { Select } from "./pages/select.jsx";
import { Data } from "./pages/data.jsx";
import { useState, useEffect } from "react";
import { Login } from "./pages/login.jsx";
import { Register } from "./pages/register.jsx";
import { Profile } from "./pages/profile.jsx";
import { useCookies } from "react-cookie";

function App() {
  const [data, setData] = useState("pimiento");
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null);
  const [section, setSection] = useState("search");
  const [selectedSailing, setSelectedSailing] = useState(null);
  const [selectedSailingBack, setSelectedSailingBack] = useState(null);
  const [selectedTariff, setSelectedTariff] = useState(null);
  const [passengerData, setPassengerData] = useState(null);

  const searchData = (searchData) => {
    setData(searchData);
  };

  const changeSection = (changeSection) => {
    setSection(changeSection);
  };

  const storePassengerData = (data, passengerID) => {

  }

  const [cookies, setCookie, removeCookie] = useCookies(["session"]);

  useEffect(() => {
   
    if(cookies) {
      setUser(cookies.session);
      setUsername(cookies.username);
    }
  }, [])
  

  return (
    <>
      <Header changeSection={changeSection} user={user} username={username} />
      {section === "search" && (
        <Home searchData={searchData} changeSection={changeSection} />
      )}
      {section === "select" && (
        <Select searchData={data} changeSection={changeSection} setSelectedSailing={setSelectedSailing} setSelectedSailingBack={setSelectedSailingBack} selectedSailing={selectedSailing}/>
      )}
      {section === "data" && (
        <Data user={user} searchData={data} changeSection={changeSection} selectedSailing={selectedSailing} selectedSailingBack={selectedSailingBack} />
      )}
      {section === "login" && (
        <Login setUser={setUser} changeSection={changeSection} /> 
      )}
      {section === "register" && (
        <Register setUser={setUser} changeSection={changeSection} /> 
      )}
      {section === "profile" && (
        <Profile user={user} setUser={setUser} changeSection={changeSection} /> 
      )}
    </>
  );
}

export default App;
